import { gql } from "@apollo/client";

export const SERVICE_RATES_QUERY = gql`
  query ServiceRates($district_id: Int!, $offset: Int) {
    Rating {
      getDistrictRate(district_id: $district_id, offset: $offset) {
        rate
        rate_count
        electricity_water_rate
        internet_rate
        streets_rate
        medical_services_rate
        educational_services_rate
        list {
          id
          created_time
          rate
          comment
        }
      }
    }
  }
`;
